import { Mappable, Mapped } from '../../rest/decorators/mapped'

@Mapped({})
export class JobType extends Mappable {
  id!: string
  title!: string
  category!: string

  static create<Data>(attrs: Data) {
    return new JobType().map(attrs)
  }
}
